import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { ValidationService } from '../validation.service';

export function emailValidator(service: ValidationService): AsyncValidatorFn {
  return (control: AbstractControl): Observable<any> => service.validateEmail(control.value);
}
